module.exports = __webpack_public_path__ + "img/ic-txt-list-edit.ebc81e05.svg";